import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
//api
import { getAllBookStores } from 'api/company';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchCompanyInput = ({ 
  value, 
  onSelected, 
  defaultCompany = null, 
  hasLabel = true, 
  placeholder, 
  className = '',
  isDisabled = false,
  label = '',
  isMulti = false,
  menuPlacement = 'auto'
}) => {
  const { t } = useTranslation(['backoffice']);
  const [companySelected, setCompanySelected] = useState(null);

  useEffect(() => {
    if (defaultCompany) {
      if (isMulti && Array.isArray(defaultCompany)) {
        setCompanySelected(defaultCompany.map(company => ({
          label: company.fiscal_name || company.name,
          value: company.id,
        })));
      } else if (!isMulti && defaultCompany) {
        setCompanySelected({
          label: defaultCompany.fiscal_name || defaultCompany.name,
          value: defaultCompany.id,
        });
      } else {
        setCompanySelected(null);
      }
    } else setCompanySelected(null)
  }, [defaultCompany, isMulti]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getAllBookStores({ 
        name: value, 
        page: 1, 
        page_size: 10, 
        fields: 'id,name,fiscal_name' 
      });
      if (status === 200) {
        return data?.results?.map((item) => ({
          ...item,
          label: item.fiscal_name || item.name,
          value: item.id,
        }));
      }
    }
    return [];
  };

  const finalPlaceholder = placeholder ? placeholder : t('searchByName');
  
  return (
    <AutoCompleteInput
      defaultOptions={isMulti && Array.isArray(companySelected) ? companySelected : (companySelected ? [companySelected] : [])}
      defaultValue={companySelected}
      value={value}
      label={hasLabel ? label : ''}
      placeholder={finalPlaceholder}
      onSearch={onSearch}
      onSelect={onSelected}
      className={className}
      isDisabled={isDisabled}
      isMulti={isMulti}
      menuPlacement={menuPlacement}
    />
  );
};

SearchCompanyInput.propTypes = {
  onSelected: PropTypes.func,
  value: PropTypes.any,
  defaultCompany: PropTypes.any,
  hasLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  menuPlacement: PropTypes.string
};

export default SearchCompanyInput;
